import { Container, Nav, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faGithub, faTrello } from "@fortawesome/free-brands-svg-icons"

export function Footer() {
  return <Navbar sticky="bottom">
    <Container>
      <Nav>
        <Nav.Link
          href="https://github.com/lewis-catley/fpl-app"
          target={"_blank"}
        >
          <FontAwesomeIcon icon={faGithub} />
          Repo
        </Nav.Link>
        <Nav.Link
          href="https://trello.com/b/Mog8398I/fpl-app"
          target={"_blank"}
        >
          <FontAwesomeIcon icon={faTrello} />
          Trello Board
        </Nav.Link>
      </Nav>
    </Container>
  </Navbar>
}
